import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(campaigns-registration)/(bridgewater)/components/leaderboard-tabs.tsx");
